enum OutgoingPayloadEvent {
  // Other
  V1_GET_RESTAURANT_CATEGORIES = "v1_get_restaurant_categories",

  // User
  V1_USER_GUEST_LOGIN = "v1_user_guest_login",
  V1_USER_GET = "v1_user_get",

  // Group
  V1_GROUP_CREATE = "v1_group_create",
  V1_GROUP_JOIN = "v1_group_join",
  V1_GROUP_READY = "v1_group_ready",
  V1_GROUP_RESTAURANT_CATEGORY_PREFERENCES = "v1_group_restaurant_category_preferences",
  V1_GROUP_RESTAURANT_PREFERENCES = "v1_group_restaurant_preferences",
}

export default OutgoingPayloadEvent;
